import { Spinner } from "@salt-ds/core";

const Loader = () => {
  return (
    <>
      <div
        className="flex h-screen w-full bg-white justify-center items-center"
      >
        <Spinner aria-label="loading" role="status" size="large" />
      </div>
    </>
  );
};

export default Loader;
